import { useEffect } from 'react';
import { useUser } from '@clerk/react';
import { trackSignUpOnce } from '@/lib/analytics';

/** Fires the Google Ads `sign_up` conversion for a brand-new account (GizmoData Cloud only). */
export const SignupConversion = () => {
  const { isLoaded, user } = useUser();
  useEffect(() => {
    if (isLoaded && user) {
      trackSignUpOnce({ id: user.id, createdAt: user.createdAt, externalAccounts: user.externalAccounts });
    }
  }, [isLoaded, user]);
  return null;
};
